var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unit)?_c('span',[_c('span',{staticClass:"qty-label"},[_vm._v("\n    "+_vm._s(_vm.unitLabel())+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }